import { NgbDateAdapter, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

export class NgbDateStructAdapter extends NgbDateAdapter<NgbDateStruct> {
  /**
   * Converts a NgbDateStruct value into NgbDateStruct value
   */
  fromModel(date: NgbDateStruct | null): NgbDateStruct | null {
    return (date && isInteger(date.year) && isInteger(date.month) && isInteger(date.day)) ?
      { year: date.year, month: date.month, day: date.day } :
      null;
  }

  /**
   * Converts a NgbDateStruct value into NgbDateStruct value
   */
  toModel(date: NgbDateStruct | null): NgbDateStruct | null {
    return (date && isInteger(date.year) && isInteger(date.month) && isInteger(date.day)) ?
      { year: date.year, month: date.month, day: date.day } :
      null;
  }

}
export function isInteger(value: any): value is number {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
